
/**
 * 模型显示模式枚举。
 *
 * 设计说明：
 * 1. 该枚举只表达 SolidWorks 对齐的有限显示样式；
 * 2. web-client 与 cad-core 共用同一枚举，避免页面层散落字符串；
 * 3. 后续扩展线框、隐藏线等模式时，只新增枚举项并扩展渲染控制器。
 */
export enum ModelDisplayMode {
    /** 带边线上色。 */
    ShadedWithEdges = 'shaded-with-edges',
    /** 上色。 */
    Shaded = 'shaded',
    /** 不着色。 */
    Unshaded = 'unshaded',
}

